import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPartRequestHistory } from "../../reduxStore/entities/historylogs.js";

import Table from "../../components/Table/Table.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardBody from "../../components/Card/CardBody.js";

import resources from "../../core/Localization/Localization.js";
import { defaultTableSize } from "../../common/UserDetailsLayout";
import moment from "moment";
import { historyColumns } from "../../common/HistoryTabs.js";

const RequestHistory = (props) => {
    const navigate = useNavigate();

    const partrequest = useSelector((s) => s.partrequestDetails.partrequest);

    const partRequestHistory = useSelector((x) => x.historyLogs.partRequestHistory);
    const dispatch = useDispatch();

    const [tableData, setTableData] = React.useState([]);

    const columns = React.useMemo(historyColumns, [resources]);

    React.useEffect(() => {
        dispatch(getPartRequestHistory(partrequest.part_request_id));
    }, [partrequest]);

    React.useEffect(() => {
        const uh = [...partRequestHistory];
        if (uh && uh.length > 1) {
            uh.sort((x, y) => {
                if (x.createdAt > y.createdAt) {
                    return -1;
                }
                if (x.createdAt < y.createdAt) {
                    return 1;
                }
                return 0;
            });
        }
        setTableData(
            uh.map((x) => {
                return [
                    x.history_log_id + "",
                    `${x.model} ${x.action}`,
                    resources.historyLogs[x.type.toLowerCase()],
                    moment(x.createdAt).format("DD/MM/YYYY hh:mm:ss"),
                ];
            })
        );
    }, [partRequestHistory]);

    const onRowClick = (params) => {
        if (params.length) {
            navigate("/admin/history-logs/" + params[0]);
        }
    };

    return (
        <Card className={"user-profile-card"}>
            <CardHeader color="primary">
                <h4>{resources.historyLogs.header}</h4>
            </CardHeader>
            <CardBody>
                <Table
                    tableHeaderColor="primary"
                    tableHead={columns}
                    tableData={tableData}
                    handleClick={onRowClick}
                    paginationInfo={{
                        pageSize: defaultTableSize,
                        pageSizeOptions: [defaultTableSize],
                    }}
                />
            </CardBody>
        </Card>
    );
};

export default RequestHistory;
